/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AvailableItems } from './AvailableItems';
import {
    AvailableItemsFromJSON,
    AvailableItemsFromJSONTyped,
    AvailableItemsToJSON,
    AvailableItemsToJSONTyped,
} from './AvailableItems';

/**
 * 
 * @export
 * @interface SalesOrderItemAvailabilityByMonth
 */
export interface SalesOrderItemAvailabilityByMonth {
    /**
     * 
     * @type {Array<AvailableItems>}
     * @memberof SalesOrderItemAvailabilityByMonth
     */
    itemAvailabilityGroupByMonth: Array<AvailableItems>;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilityByMonth
     */
    countAllArticle: number;
}

/**
 * Check if a given object implements the SalesOrderItemAvailabilityByMonth interface.
 */
export function instanceOfSalesOrderItemAvailabilityByMonth(value: object): value is SalesOrderItemAvailabilityByMonth {
    if (!('itemAvailabilityGroupByMonth' in value) || value['itemAvailabilityGroupByMonth'] === undefined) return false;
    if (!('countAllArticle' in value) || value['countAllArticle'] === undefined) return false;
    return true;
}

export function SalesOrderItemAvailabilityByMonthFromJSON(json: any): SalesOrderItemAvailabilityByMonth {
    return SalesOrderItemAvailabilityByMonthFromJSONTyped(json, false);
}

export function SalesOrderItemAvailabilityByMonthFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOrderItemAvailabilityByMonth {
    if (json == null) {
        return json;
    }
    return {
        
        'itemAvailabilityGroupByMonth': ((json['itemAvailabilityGroupByMonth'] as Array<any>).map(AvailableItemsFromJSON)),
        'countAllArticle': json['countAllArticle'],
    };
}

export function SalesOrderItemAvailabilityByMonthToJSON(json: any): SalesOrderItemAvailabilityByMonth {
    return SalesOrderItemAvailabilityByMonthToJSONTyped(json, false);
}

export function SalesOrderItemAvailabilityByMonthToJSONTyped(value?: SalesOrderItemAvailabilityByMonth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'itemAvailabilityGroupByMonth': ((value['itemAvailabilityGroupByMonth'] as Array<any>).map(AvailableItemsToJSON)),
        'countAllArticle': value['countAllArticle'],
    };
}

